// EVM address to receive funds on Hedera testnet
export const DEFAULT_RECEIVER_EVM = "0xd4b3a283178fe3d5deb067a99d77fd4cf150daf4";


